import { hydrate } from "@ribit/lib";

class Portfolio {
  link: string;
  @hydrate
  createdAt: Date;
}

export default Portfolio;
